import React, { Component } from 'react';

import { RelatedEntityGrid as EntityGrid } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { ModelTextArea } from 'hay-core-react';
import { ModelInputNumber } from 'hay-core-react';
import { ModelBoolean } from 'hay-core-react';
import { Usuario } from 'hay-core-react';

import PesquisaEnvio         from '../../../models/PesquisaEnvio';
import Pesquisa              from '../../../models/Pesquisa';
import PesquisaExecucaoLog   from '../../../models/PesquisaExecucaoLog';
import PesquisaTipoEnvioEnum from '../../../enums/PesquisaTipoEnvioEnum';
import PesquisaTipoEnum      from '../../../enums/PesquisaTipoEnum';

// ─── Esquema de campos ────────────────────────────────────────────────────────

const model = {
    pesquisa: {
        exibir:       'main.pesquisaenvio.pesquisa',
        visivel:      true,
        tipo:         'relacao',
        camporelacao: 'nome',
        entidade:     'pesquisa.entidade',
        template:     'pesquisa.template',
    },
    usuario: {
        exibir:       'main.pesquisaenvio.usuario',
        visivel:      true,
        tipo:         'relacao',
        camporelacao: 'nome',
        entidade:     'usuario.entidade',
        template:     'usuario.template',
    },
    // Reusa o mesmo enum de Pesquisa.tipoenvio - canal e' snapshot desse mesmo campo/namespace no
    // momento do envio (ver comentario em PesquisaEnvio.js no backend).
    canal: {
        exibir:   'main.pesquisaenvio.canal',
        visivel:  true,
        tipo:     'enum',
        entidade: 'pesquisa.tipoenvio',
    },
    // Reusa o mesmo enum de Pesquisa.tipo - mesmo raciocinio de canal acima.
    tipo: {
        exibir:   'main.pesquisaenvio.tipo',
        visivel:  true,
        tipo:     'enum',
        entidade: 'pesquisa.tipo',
        largura: "7rem",
    },
    respondida: {
        exibir:   'main.pesquisaenvio.respondida',
        visivel:  true,
        tipo:     'boolean',
        template: 'respondida.template',
        largura: "6rem",
    },
    // So preenchidas quando respondida=true (ver PesquisaResposta.registrarResposta).
    nota: { exibir: 'main.pesquisaenvio.nota', visivel: true, tipo: 'numeric', largura: '6rem' },
    comentario: { exibir: 'main.pesquisaenvio.comentario', hidegrid: true },
    createdAt: { exibir: 'main.createdAt', visivel: true, tipo: 'date', time: true },
    execucaolog: {
        exibir:       'main.pesquisaenvio.execucaolog',
        tipo:         'relacao',
        camporelacao: 'datahorainicio',
        entidade:     'execucaolog.entidade',
        template:     'execucaolog.template',
        hidegrid:     true,
    },
    token: { exibir: 'main.pesquisaenvio.token', hidegrid: true },
    envioorigemmodel: { exibir: 'main.pesquisaenvio.envioorigemmodel', hidegrid: true },
    envioorigemid: { exibir: 'main.pesquisaenvio.envioorigemid', hidegrid: true },
};

// ─── Renderers customizados ───────────────────────────────────────────────────

const booleanTemplate = (campo) => (rowData) => (
    <i className={`pi ${rowData[campo] ? 'pi-check text-green-500' : 'pi-times text-red-400'}`}></i>
);

const renderers = {
    pesquisa:     { entidade: Pesquisa, template: (rowData) => rowData.pesquisa?.nome || rowData.pesquisa?.id || '' },
    usuario:      { entidade: Usuario, template: (rowData) => rowData.usuario?.nome || rowData.usuario?.id || '' },
    execucaolog:  { entidade: PesquisaExecucaoLog, template: (rowData) => rowData.execucaolog?.id || '' },
    'pesquisa.tipoenvio': PesquisaTipoEnvioEnum,
    'pesquisa.tipo':      PesquisaTipoEnum,
    respondida:   { template: booleanTemplate('respondida') },
};

// ─── Formulário (só "Ver" - convite gerado pelo processo de Pesquisa) ─────────

class PesquisaEnvioFormulario extends Component {
    render() {
        const { model, contexto } = this.props;
        return (
            <div className="grid">
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={{ ...model.pesquisa, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={{ ...model.usuario, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelDropDown model={{ ...model.canal, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelDropDown model={{ ...model.tipo, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelBoolean model={{ ...model.respondida, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelInputNumber model={{ ...model.nota, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-8 mt-3">
                    <ModelDropDown model={{ ...model.execucaolog, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 mt-3">
                    <ModelTextArea model={{ ...model.comentario, disabled: true }} contexto={contexto} rows={3} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelTextInput model={{ ...model.token, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-3 mt-3">
                    <ModelTextInput model={{ ...model.envioorigemmodel, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-3 mt-3">
                    <ModelTextInput model={{ ...model.envioorigemid, disabled: true }} contexto={contexto} />
                </div>
            </div>
        );
    }
}

// ─── Template (componente exportado) ─────────────────────────────────────────

class PesquisaEnvioTemplate extends Component {
    render() {
        return (
            <EntityGrid
                entidade={PesquisaEnvio}
                model={model}
                identidade="main.pesquisaenvio"
                permissoes={this.props.permissoes}
                icone="pi-send"
                storageKey="dt-pesquisaenvios"
                relacionados={[]}
                renderers={renderers}
                configuracao={this.props.configuracao}
                ordenacaoPadrao={{ sortField: 'createdAt', sortOrder: -1 }}
                formulario={(m, ctx) => <PesquisaEnvioFormulario model={m} contexto={ctx} />}
            />
        );
    }
}

export default PesquisaEnvioTemplate;
